import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { CookieService } from 'ngx-cookie-service';
import Swal from 'sweetalert2';
import { Router } from '@angular/router';
import { ApiService } from '../../../../core/services/api.service';

import {
  FinanceCoupon,
  FinanceCouponPayload,
  FinanceCouponResponse,
  MasterFee,
} from '../../../../core/models/information.model';
import {
  InforProviders,
  Providers,
  VehicleDetail,
  InformationResponse,
  Province,
  Color,
  FeeType,
  StatusAPIResponse,
  Blank,
  TaxpayerInfo,
} from '../../../../core/models/information.model';
import { Turtle } from 'lucide-angular';
import { CarList, licenseInsertList, MemberLineResponse, RegisterMemberPayload } from '../../../../core/models/member.model';
import { InsertLicensePayload, InsertLicenseResponse, MyAddressAllResponse, MyMemberCard, MyVehicleAllResponse } from '../../../../core/models/user.model';
import { FeeDetailsResponse } from '../../../../core/models/parking.model';
import * as XLSX from 'xlsx';
import { forkJoin } from 'rxjs';
import { ToastService } from 'angular-toastify';
import { InputComponent } from "../../../../tools/forms/input/input.component";
import { ApiFormService } from '../../../../core/services/api-form.service';

@Component({
  selector: 'app-coupon-generate',
  imports: [CommonModule, FormsModule, InputComponent],
  templateUrl: './coupon-generate.component.html',
  styleUrl: './coupon-generate.component.css',
})
export class CouponGenerateComponent implements OnInit {
  search = '';
  page = 1;
  user_id: number = 0;
  user_name: string = '';
  searchQuery: string = '';
  modalFrom: boolean = false;
  isLoading: boolean = false;


  // Modal
  modalViewCouponInfo: boolean = false;
  showTaxModal: boolean = false;
  showModalVehiclePlate: boolean = false;
  modalCoupon: boolean = false;
  modalSelectProvider: boolean = false;
  modalSelectMemberCard: boolean = false;

  // Page
  currentPage: number = 1;
  itemsPerPage: number = 10;

  pageSizeOptions = [20, 50, 100];
  pageSize = 10;

  // totalPages: number = 0;
  financeData: FinanceCoupon[] = [];
  financePayLoad: FinanceCouponPayload | null = null;
  //View Details
  financeDetailsData: FinanceCouponPayload = {
    uid: null,
    name: null,
    feeId: null,
    quantity: null,
    freeTime: null,
    startDate: null,
    endDate: null,
    siteId: null,
    feeTypeId: null,
    pic: null,
    fullName: null,
    companyName: null,
    address: null,
    subDistrict: null,
    district: null,
    provinces: null,
    zipCode: null,
    addressType: 0,
    email: null,
    branch: null,
    branchNo: null,
    headquarters: false,
    phone: null,
    taxId: null,
    bankId: null,
    fee: null,
    taxRequired: false
  };

  //input
  name: string = '';
  feeId: number | null = null;
  freeTime: number | null = null;
  quantity: number | null = null;
  startDate: Date | null = null;
  endDate: Date | null = null;
  siteId: number | null = null;
  siteName: string = '';

  full_name: string = '';
  company_name: string = '';
  address: string = '';
  sub_district: string = '';
  district: string = '';
  provinces: string = '';
  zip_code: string = '';
  address_type: number | null = null;
  email: string = '';
  branch: string = '';
  branch_no: string = '';
  headquarters: boolean = false;
  phone: string = '';
  tax_id: string = '';
  taxRequired: boolean = false;
  fee: number | null = null;

  stampApproveListSearch: FinanceCoupon[] | null = null;



  //Modal register
  renew_: boolean = false;
  expire_date: string = '';
  allMembers: MemberLineResponse[] = [];
  selectVehicleType: string = '';
  allProviders: Providers[] = [];
  allMemberCard: MyMemberCard[] = [];
  selectMemberCard_: MyMemberCard | null = null;
  selectMember: MemberLineResponse | null = null;
  searchProvider: string = '';
  searchMemberCard: string = '';
  disabled: boolean = true;
  remarks: string = '';
  LocationOptions: { id: string; name: string }[] = [];
  selectedLocation: string = '';
  providerId: number = 0;
  providerName: string = '';
  cardMemberName: string = '';
  today: string = '';
  minStartDate: string = '';
  CarOptions: { value: string; label: string }[] = [];
  CardOptions: {
    value: number;
    label: string;
    fig_day: number;
    vehicle_type_name: string;
    subscription_id: number;
  }[] = [];
  FeeIdOptions: MasterFee[] = [];
  selectedOption: number | null = null;
  selectedCar: string | null = null;
  selectedBrand: string | null = null;
  selectedFeeType: number | null = null;
  selectedAccountId: number | null = null;
  selectEngine: string | null = null;
  selectedModel: string | null = null;
  selectedColor: string | null = null;
  subscription_id: number | null = null;
  fullFeeList: FeeDetailsResponse[] = []; // เก็บไว้กรองซ้ำได้
  carFilteredPlateList: MyVehicleAllResponse[] = [];
  FeeTypeOptions: { value: number; label: string; status: boolean }[] = [];
  showBank: boolean = false;
  BankOptions: { value: number; label: string }[] = [];
  couponDetails: VehicleDetail[] = [];
  BrandOptions: { value: string; label: string }[] = [];
  ModelOptions: { value: string; label: string }[] = [];
  ColorOptions: { value: string; label: string }[] = [];
  ProvinceOptions: { value: string; label: string }[] = [];
  selectedProvince: any = null;
  customer_name: string = '';
  fig_day: number | null = null;
  phoneNo: string = '';
  error: string = '';
  modalSelectVehicle: boolean = false;
  license: string = '';
  selectedLicense: string = '';
  licenseAll: MyVehicleAllResponse[] = [];
  carPlateList: MyVehicleAllResponse[] = [];
  CardCode: string = '';

  // Modal Vehicle Plate
  selectCarPlate: MyVehicleAllResponse[] = [];
  isOpen: boolean = false;
  searchTerm: string = ''; // คำค้นหา
  isRequestTax: boolean = false;
  selectedTaxType: string = '1';
  filteredAddressList: MyAddressAllResponse[] = [];
  selectedAddress: MyAddressAllResponse | null = null;
  addressListAll: MyAddressAllResponse[] = [];
  address_id: number = 0;
  showSelectAddress: boolean = false;
  mainOffice: boolean = false;
  taxName: string = '';
  taxId: string = '';
  province_name: string | null = null;
  amphure_name: string | null = null;
  tambon_name: string | null = null;
  tax_phone: string = '';
  branchName: string = '';
  branchNo: string = '';
  provincess: any[] = [];
  selectedProvinceId: number | null = null;
  filteredAmphures: any[] = [];
  amphures: any[] = [];
  selectedAmphureId: number | null = null;
  filteredTambons: any[] = [];
  tambons: any[] = [];
  selectedTambonId: number | null = null;
  zipcode: string = '';
  showAddressModal: boolean = false;
  selectedFile: File | null = null;
  previewUrl: string | ArrayBuffer | null = null;
  vehicleId: number = 0;
  base64String: string = '';
  licenseTxt: string = '';
  brandTxt: string = '';
  modelTxt: string = '';
  colorTxt: string = '';
  provinceTxt: string = '';

  // License plate list check
  licenseFilteredPlateList: MyVehicleAllResponse[] = [];
  selectLicensePlate: MyVehicleAllResponse[] = [];
  insertLicensePlate: licenseInsertList = {
    license: '',
    brand: '',
    model: '',
    color: '',
    province: '',
  };

  zip: any;



  constructor(
    private apiService: ApiService,
    private apiFormService: ApiFormService,
    private router: Router,
    private cookieService: CookieService,
    private http: HttpClient,
    private toast: ToastService
  ) { }

  async ngOnInit(): Promise<void> {
    this.user_id = parseInt(this.cookieService.get('user_id'));
    this.user_name = this.cookieService.get('name');

    this.getProviders();
    this.getFeeId();
    this.requestGetCouponDetail();
    this.getFeeType();

    setTimeout(() => {
      forkJoin({
        tambons: this.http.get<any[]>('json/thai_tambons.json'),
        amphures: this.http.get<any[]>('json/thai_amphures.json'),
        provinces: this.http.get<any[]>('json/thai_provinces.json'),
      }).subscribe({
        next: (response) => {
          this.tambons = response.tambons;
          this.amphures = response.amphures;
          this.provincess = response.provinces;

          // setTimeout(() => {
          //   this.getApiAddressAll();
          // }, 100);
        },
        error: (err) => {
          console.error('โหลดข้อมูลล้มเหลว', err);
        },
      });
    }, 1000);
  }

  /* ----------------------------------------- Functions --------------------------------- */

  // Table
  get totalPages(): number {
    return Math.ceil((this.stampApproveListSearch ? this.stampApproveListSearch : this.financeData)
      .length / this.pageSize);
  }

  get paginatedData() {
    const start = (this.currentPage - 1) * this.pageSize;
    return (this.stampApproveListSearch ? this.stampApproveListSearch : this.financeData)
      .slice(start, start + this.pageSize);
  }

  nextPage() {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
    }
  }

  prevPage() {
    if (this.currentPage > 1) {
      this.currentPage--;
    }
  }

  onSearchCoupon(value: any) {
    this.searchQuery = (value || '').toLowerCase();
    if (this.searchQuery !== '') {
      this.stampApproveListSearch = this.financeData.filter((item: any) =>
        (item.name || '').toLowerCase().includes(this.searchQuery)
      );
    } else {
      // reset ค่า
      this.stampApproveListSearch = null;
    }
    this.currentPage = 1;
  }

  ViewInfo(data: FinanceCoupon) {
    this.modalViewCouponInfo = true;

    this.getApiCouponInfo(data);
  }




  openFrom() {
    this.modalCoupon = true;
  }

  /* ------ Modal Register ------ */
  openLocationModal() {
    this.modalSelectProvider = true;
  }
  openMemberCardModal() {
    this.modalSelectMemberCard = true;
    //console.log(this.selectMember);
    const uid = this.selectMember?.lineId;
    if (this.providerId > 0) {
      this.getMemberCardApi(this.providerId, uid ?? '');
      this.getUserVehicleAll();
    } else {
    }
  }
  setValueVehicle(response: MyVehicleAllResponse[]) {
    // --- กรองข้อมูลทะเบียนรถ ---
    this.licenseAll = response;
    //console.log('licenseAll', this.selectVehicleType);
    // ใส่ป้ายทะเบียนเริ่มต้น
    this.carPlateList = this.licenseAll.filter(
      (item) => item.vehicle_type_name === this.selectVehicleType
    );
    this.selectLicensePlate = this.carPlateList;
    //console.log('carPlateList', this.carPlateList);
    this.handleSelectVehicleType(this.selectVehicleType);
  }
  handleSelectVehicleType(vehicleType: string): void {
    //console.log(vehicleType);
    this.selectVehicleType = vehicleType;
    const selectedOption = this.CarOptions.find(
      (option) => option.value === vehicleType
    );
    if (selectedOption) {
      this.CardOptions = [];
      this.selectedOption = null;
      this.subscription_id = 0;
      this.selectedCar = vehicleType;

      if (this.selectVehicleType !== vehicleType) {
        this.selectCarPlate = [];
        this.fig_day = 0;
        this.subscription_id = 0;
        this.fee = 0;
      }

      this.CardOptions = this.fullFeeList
        .filter((fee) => fee.vehicle_name === this.selectedCar)
        .map((fee) => ({
          value: fee.id,
          label: `${fee.name} ( ${fee.fee} บาท )`,
          fig_day: fee.fig_day,
          vehicle_type_name: fee.vehicle_name,
          subscription_id: fee.subscription_id,
        }));
      //console.log('licenseAll Vehicle: ', this.licenseAll);
      // Filter Vehicle plate list
      this.carPlateList = this.licenseAll.filter(
        (vehicle) => vehicle.vehicle_type_name === this.selectVehicleType
      );

      //console.log('carPlateList : ', this.carPlateList);

      this.selectedOption = null;
      //console.log('CardOptions', this.CardOptions);
      //console.log('selectedOption', this.selectedOption);
      this.updateBrandOptions(selectedOption.value, '');
    }
  }
  updateBrandOptions(vehicleType: string, preselectBrand?: string): void {
    const filteredBrands = this.couponDetails
      .filter((vehicle) => vehicle.vehicle_type_name === vehicleType)
      .map((vehicle) => vehicle.vehicle_brand_name);

    const uniqueBrands = [...new Set(filteredBrands)];
    this.selectedBrand = '';
    this.selectedModel = '';

    this.BrandOptions = uniqueBrands.map((brand) => ({
      value: brand,
      label: brand,
    }));

    // ✅ ถ้ามีค่าที่ต้องการเลือกไว้ล่วงหน้า
    if (preselectBrand) {
      // //console.log('เลือกแบร์นมา ', preselectBrand);
      const defaultBrand = this.BrandOptions.find(
        (opt) => opt.value === preselectBrand
      );
      this.selectedBrand = defaultBrand ? defaultBrand.value : null;
    }
  }
  handleFeeType(event: any): void {
    const selectedValue = + event.target.value; // แปลงเป็น number
    this.selectedFeeType = selectedValue;
    const selectedOption = this.FeeTypeOptions.find(
      (opt) => opt.value === selectedValue
    );
    this.showBank = selectedOption?.status ?? false;
    // //console.log('Selected FeeType ID:', this.selectedFeeType);
  }
  handleAccount(event: any): void {
    this.selectedAccountId = event.target.value;
  }
  handleFeeId(event: any): void {
    this.feeId = event.target.value;
  }
  onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.selectedFile = input.files[0];
      const reader = new FileReader();
      reader.onload = () => {
        this.previewUrl = reader.result;
        // แปลงเป็น base64 string
        const result = reader.result as string;
        const base64 = result.split(',')[1]; // ตัด header ออก เช่น "data:image/png;base64,"
        this.base64String = base64;
      };

      reader.readAsDataURL(this.selectedFile);
    }
  }
  handlePackChange(value: number | string): void {
    const numericValue =
      typeof value === 'string' ? parseInt(value, 10) : value;
    // //console.log('🔄 handlePackChange:', numericValue);

    const selected = this.CardOptions.find(
      (option) => option.value === numericValue
    );
    // //console.log('🎯 selectedOption:', selected);
    this.selectedOption = numericValue;
    if (selected) {
      this.fig_day = selected.fig_day;
      this.subscription_id = selected.subscription_id;
      // //console.log('✅ Selected Option ID:', numericValue);
      // //console.log('📆 Selected FigDay:', this.fig_day);
      // //console.log('📆 Selected subscription:', this.subscription_id);
    } else {
      this.fig_day = null;
      // console.warn('⚠️ ไม่พบ option ที่เลือก');
    }
  }
  filterNumberOnly(event: Event) {
    const input = event.target as HTMLInputElement;
    input.value = input.value.replace(/[^0-9]/g, '');
    this.phoneNo = input.value;
  }
  validateForm() {
    const phoneValid = /^0[0-9]{9}$/.test(this.phoneNo);
    this.error = phoneValid ? '' : 'เบอร์ไม่ถูกต้อง';
  }
  handleCheckboxChange(event: Event) {
    const checked = (event.target as HTMLInputElement).checked;
    //console.log('checkbox checked:', checked);
    // เพิ่ม logic ได้ที่นี่ เช่น เก็บค่าไว้ใน form
  }

  /* --- Vehicle Plate --- */
  filterCarPlate(event: any) {
    const searchTerm = event.target.value.toLowerCase();
    this.carFilteredPlateList = this.carPlateList.filter((vehicle) =>
      vehicle.plate_number.toLowerCase().includes(searchTerm)
    );
  }
  toggleModalVehiclePlate() {
    this.showModalVehiclePlate = !this.showModalVehiclePlate;
  }
  toggleSelect(vehicle: MyVehicleAllResponse, event: Event) {
    event.stopPropagation(); // ป้องกันไม่ให้ blur แล้ว dropdown ปิด

    const index = this.selectLicensePlate
      .map((item) => item.plate_number)
      .indexOf(vehicle.plate_number);

    if (index > -1) {
      this.selectLicensePlate.splice(index, 1);
    } else {
      // เพิ่ม Model ลงใน selectLicensePlate
      this.selectLicensePlate.push(vehicle);

      //console.log('✅ Selected Plates ! :', this.selectLicensePlate);
    }
  }
  isSelected(plate: string): boolean {
    return this.selectLicensePlate
      .map((item) => item.plate_number)
      .includes(plate);
  }
  onExcelFileSelected(event: any): void {
    const target: DataTransfer = <DataTransfer>event.target;
    if (target.files.length !== 1) {
      console.error('กรุณาเลือกไฟล์เพียงไฟล์เดียว');
      return;
    }

    const reader: FileReader = new FileReader();
    reader.onload = (e: any) => {
      const binaryStr: string = e.target.result;
      const workbook: XLSX.WorkBook = XLSX.read(binaryStr, { type: 'binary' });

      const sheetName: string = workbook.SheetNames[0]; // ใช้ชีทแรก
      const worksheet: XLSX.WorkSheet = workbook.Sheets[sheetName];
      const data = XLSX.utils.sheet_to_json(worksheet, { defval: '' });
      var dataInfoList: licenseInsertList[] | any = [];

      // แปลงข้อมูลเพิ่มเข้า list
      data.forEach((row: any) => {
        if (
          row['plate_number'] != '' &&
          row['province_name'] != '' &&
          row['brand_name'] != '' &&
          row['model_name'] != '' &&
          row['color_name'] != ''
        ) {
          const newItem: licenseInsertList = row;
          dataInfoList.push(newItem);

          // เพิ่มแบบเปลี่ยน reference
          //this.licenseAll = [...this.licenseAll, newItem];
        }
      });

      this.sentLincenseInsert(dataInfoList);
      //console.log('นำเข้าข้อมูลสำเร็จ', dataInfoList);
    };

    reader.readAsBinaryString(target.files[0]);
  }

  // License insert
  sentLincenseInsert(data: InsertLicensePayload) {
    this.apiService.InsertLicense(data).subscribe({
      next: (res: InsertLicenseResponse) => {
        //console.log('InsertLicense res : ', res);
        if (res.code == '000') {
          this.clearText();
          this.showModalVehiclePlate = false;
          this.getUserVehicleAll();
          this.toast.success('บีนทึกทะเบียนสำเร็จ');
        } else {
          this.toast.error(res.message);
        }
      },
      error: (err) => {
        console.error('การบันทึกไม่สำเร็จ', err);
      },
    });
  }

  clearText() {
    this.licenseTxt = '';
    this.provinceTxt = '';
    this.brandTxt = '';
    this.modelTxt = '';
    this.colorTxt = '';
    this.selectedBrand = '';
    this.ModelOptions = [];
    this.selectedModel = '';
    this.selectEngine = '';
    this.selectedColor = '';
  }


  submitRequest() {
    //console.log(this.startDate, this.endDate);
    if (!this.siteName.trim()) {
      this.toast.warn('กรุณาเลือกสถานที่ให้บริการ');
    } else if (this.selectedFeeType == null || this.selectedFeeType == 0) {
      this.toast.warn('กรุณาเลือกประเภทการรับชำระ');
    } else if (
      this.startDate != null &&
      this.endDate != null &&
      this.startDate > this.endDate
    ) {
      this.toast.warn('วันที่สิ้นสุด ต้องมากกว่าวันที่เริ่มต้น');
    } else if (this.selectedFeeType == 3 && (this.selectedAccountId == null || this.selectedAccountId == 0)) {
      this.toast.warn('กรุณาเลือกบัญชีธนาคาร');
    } else if (this.quantity == 0 || this.quantity == null) {
      this.toast.warn('กรุณาระบุจํานวน');
    } else if (this.freeTime == 0 || this.freeTime == null) {
      this.toast.warn('กรุณาระบุเวลาฟรี');
    } else if (this.startDate == null || this.endDate == null) {
      this.toast.warn('กรุณาระบุวันที่เริ่มต้นและสิ้นสุด');
    }
    else if (this.isRequestTax) {
      if (
        !this.taxName.trim() &&
        !this.taxId.trim() &&
        !this.address.trim() &&
        this.selectedProvinceId === null &&
        this.selectedAmphureId === null &&
        this.selectedTambonId === null
      ) {
        this.toast.warn('กรุณาเพิ่มข้อมูลใบกำกับภาษีก่อน');
      } else if (!this.taxName.trim()) {
        this.toast.warn('กรุณาระบุ ชื่อผู้เสียภาษี');
      } else if (
        !this.branchName.trim() &&
        !this.branchNo.trim() &&
        !this.mainOffice &&
        this.selectedTaxType === '2'
      ) {
        //console.log();
        this.toast.warn('กรุณาระบุ สาขาและรหัสสาขา');
      } else if (!this.taxId.trim()) {
        this.toast.warn('กรุณาระบุ เลขประจำตัวผู้เสียภาษี');
      } else if (!this.address.trim()) {
        this.toast.warn('กรุณาระบุ ที่อยู่');
      } else if (!this.tax_phone.trim()) {
        this.toast.warn('กรุณาระบุ เบอร์โทรศัพท์ ใบกำกับภาษี');
      } else if (this.selectedProvinceId === null) {
        this.toast.warn('กรุณาระบุ จังหวัด');
      } else if (this.selectedAmphureId === null) {
        this.toast.warn('กรุณาระบุ อำเภอ');
      } else if (this.selectedTambonId === null) {
        this.toast.warn('กรุณาระบุ ตำบล');
      } else if (!this.zipcode) {
        this.toast.warn('กรุณาระบุ เลขไปรษณีย์');
      } else {
        this.confirmSaveData();
      }
    } else {
      this.confirmSaveData();
    }

  }
  confirmSaveData() {
    Swal.fire({
      icon: 'error',
      title: 'แน่ใจหรือไม่?',
      text: 'คุณได้ตรวจสอบข้อมูลแล้ว ต้องการดำเนินการต่อหรือไม่?',
      showCancelButton: true,
      confirmButtonText: 'ตกลง',
      cancelButtonText: 'ยกเลิก',
      reverseButtons: true, // ให้ปุ่มตกลงอยู่ขวา ยกเลิกอยู่ซ้าย
    }).then((result) => {
      if (result.isConfirmed) {
        // //console.log('ดำเนินการต่อ...');
        this.saveMemberRegister();
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        //console.log('ยกเลิกการทำงาน');
      }
    });
  }
  saveMemberRegister() {
    Swal.fire({
      title: 'กำลังบันทึกข้อมูล...',
      allowOutsideClick: false,
      allowEscapeKey: false,
      allowEnterKey: false,
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    // ข้อมูลที่จะส่ง
    const payload: FinanceCouponPayload = {
      uid: this.user_id,
      name: this.name,
      feeId: this.feeId,
      feeTypeId: this.selectedFeeType ? this.selectedFeeType : 0,
      fee: this.fee,
      quantity: this.quantity,
      freeTime: this.freeTime,
      startDate: this.startDate,
      endDate: this.endDate,
      siteId: this.siteId,
      pic: this.base64String,
      taxRequired: this.isRequestTax,
      fullName: this.taxName,
      addressType: parseInt(this.selectedTaxType || '0', 10),
      address: this.address || '',
      subDistrict: this.tambon_name || '',
      district: this.amphure_name || '',
      provinces: this.province_name || '',
      zipCode: this.zipcode || '',
      email: this.email || '',
      branch: this.branchName || '',
      branchNo: this.branchNo || '',
      headquarters: this.mainOffice,
      phone: this.tax_phone,
      bankId: this.selectedAccountId || 0,
      taxId: this.taxId,
      companyName: '',

    }

    //console.log('Coupon Payload sent : ', JSON.stringify(payload).toString());
    if (payload) {
      this.apiService.sentCouponInfo(payload).subscribe({
        next: (res: StatusAPIResponse) => {
          Swal.close();
          //console.log('📦 Response:', res);
          if (res.code == '000') {
            this.toast.success('สมัครสมาชิกรายเดือนเรียบร้อย');
            this.modalCoupon = false;
            this.clear();
            this.requestGetCouponDetail();
          } else {
            this.toast.error(res.message);
          }
        },
        error: (err) => {
          Swal.close();
          console.error('❌  ไม่สำเร็จ:', err);
          this.toast.error('บันทึกไม่สำเร็จ');
        },
        complete: () => {
          Swal.close();
        },
      });
    } else {
      //console.log('payload os null');
    }

  }
  clear() {
    this.name = '';
    this.siteId = null;
    this.siteName = '';
    this.providerName = '';
    this.CardCode = '';
    this.cardMemberName = '';
    this.providerId = 0;
    this.selectedCar = null;
    this.selectedFile = null;
    this.previewUrl = null;
    this.selectedFeeType = null;
    this.startDate = null;
    this.endDate = null;
    this.feeId = null;
    this.fee = null;
    this.quantity = null;
    this.freeTime = null;
    this.selectMember = null;
    this.selectMemberCard_ = null;
    this.selectVehicleType = '';
    this.selectCarPlate = [];
    this.subscription_id = null;
    this.fig_day = null;
    this.selectedOption = null;
    this.CardOptions = [];
    this.customer_name = '';
    this.phoneNo = '';
    this.licenseAll = [];
    this.license = '';
    this.selectedProvince = null;
    this.selectedBrand = '';
    this.selectedModel = '';
    this.selectedColor = '';
    this.isRequestTax = false;
    this.remarks = '';
    this.selectedTaxType = '1';
    this.mainOffice = false;
    this.taxName = '';
    this.tax_phone = '';
    this.email = '';
    this.branchName = '';
    this.branchNo = '';
    this.taxId = '';
    this.address = '';
    this.selectedProvinceId = null;
    this.selectedAmphureId = null;
    this.selectedTambonId = null;
    this.zipcode = '';
    this.base64String = '';
    this.selectedFeeType = null;
    this.BankOptions = [];
    this.selectedAccountId = 0;
    this.showBank = false;
  }


  /* --- Modal Providers --- */
  filteredProviders(): Providers[] {
    if (!this.searchProvider) return this.allProviders;
    return this.allProviders.filter((p) =>
      p.name.toLowerCase().includes(this.searchProvider.toLowerCase())
    );
  }
  selectProvider(provider: Providers) {
    this.modalSelectProvider = false;
    this.siteId = provider.id;
    this.siteName = provider.name;
    //console.log("Site ID" ,  this.siteId);
    setTimeout(() => {
      this.getFeeDetails(this.siteId ?? 0);
      this.getBank(this.siteId ?? 0);
      this.carFilteredPlateList = [];
      this.selectCarPlate = [];
    }, 200);
  }
  getFeeDetails(site_id: number) {
    this.apiService.getFeeDetails(site_id).subscribe({
      next: (response: FeeDetailsResponse[]) => {
        this.fullFeeList = response;
        this.CardOptions = []; // เริ่มต้นว่างก่อนรอเลือกประเภทรถ
        this.setCard();
      },
      error: (error) => {
        console.error('API error:', error);
      },
    });
  }

  setCard() {
    this.CardOptions = this.fullFeeList
      .filter((fee) => fee.vehicle_name === this.selectedCar)
      .map((fee) => ({
        value: fee.id,
        label: `${fee.name} ( ${fee.fee} บาท )`,
        fig_day: fee.fig_day,
        vehicle_type_name: fee.vehicle_name,
        subscription_id: fee.subscription_id,
      }));
  }

  /* --- Modal Tax --- */
  openTaxModal() {
    this.showTaxModal = true;
  }
  closeTaxModal() {
    this.showTaxModal = false;
  }
  filterAddressByTaxType(): void {
    this.filteredAddressList = [];
    this.selectedAddress = null;
    this.address_id = 0;
    const type = parseInt(this.selectedTaxType, 10); // แปลงเป็น number
    this.filteredAddressList = this.addressListAll.filter(
      (item) => item.address_user_type === type
    );
    if (this.filteredAddressList.length > 0) {
      this.showSelectAddress = true;
      this.selectedAddress = this.filteredAddressList[0];
      this.setValueAddress();
    } else {
      this.showSelectAddress = false;
      this.selectedAddress = null;
      this.setValueAddress();
    }
  }
  setValueAddress() {
    if (this.selectedAddress) {
      this.address_id = this.selectedAddress.id;
      this.mainOffice = this.selectedAddress.headquarters;
      this.taxName = this.selectedAddress.name;
      this.tax_phone = this.selectedAddress.phone;
      this.email = this.selectedAddress.email;
      this.branchName = this.selectedAddress.branch;
      this.branchNo = this.selectedAddress.branch_no;
      this.taxId = this.selectedAddress.tax_id;
      this.address = this.selectedAddress.address;
      this.tax_phone = this.selectedAddress.phone;

      const selectedProvName = this.selectedAddress?.provinces?.trim() ?? '';
      const matchedProvince = this.provincess.find(
        (p) => p.name_th.trim() === selectedProvName
      );
      if (matchedProvince) {
        this.selectedProvinceId = matchedProvince.id;
        this.province_name = selectedProvName;
      } else {
        this.selectedProvinceId = null;
        this.province_name = '';
      }

      if (this.selectedProvinceId != null) {
        const provinceId = this.selectedProvinceId;
        this.filteredAmphures = this.amphures.filter(
          (a) => a.province_id === +provinceId
        );

        const selectedAmphureName =
          this.selectedAddress?.district?.trim() ?? '';
        const matchedAmphure = this.filteredAmphures.find(
          (a) => a.name_th.trim() === selectedAmphureName
        );
        if (matchedAmphure) {
          this.selectedAmphureId = matchedAmphure.id;
          this.amphure_name = selectedAmphureName;
        } else {
          this.selectedAmphureId = null;
          this.amphure_name = '';
        }
      } else {
        this.filteredAmphures = [];
        this.selectedAmphureId = null;
        this.amphure_name = '';
      }

      if (this.selectedAmphureId != null) {
        const amphureId = this.selectedAmphureId;

        // กรองตำบลในอำเภอที่เลือก
        this.filteredTambons = this.tambons.filter(
          (a) => a.amphure_id === +amphureId
        );

        // ดึงชื่อจากที่อยู่
        const selectedTambonName =
          this.selectedAddress?.sub_district?.trim() ?? '';

        // หาใน list ว่าตรงกับตำบลไหน
        const matchedTambon = this.filteredTambons.find(
          (a) => a.name_th.trim() === selectedTambonName
        );

        if (matchedTambon) {
          this.selectedTambonId = matchedTambon.id;
          this.tambon_name = selectedTambonName;
          this.zipcode = this.selectedAddress.zip_code;
        } else {
          this.selectedTambonId = null;
          this.tambon_name = '';
          this.zipcode = '';
        }
      } else {
        this.filteredTambons = [];
        this.selectedTambonId = null;
        this.tambon_name = '';
      }
    } else {
      // ✅ ล้างค่าเมื่อไม่มี selectedAddress
      this.address_id = 0;
      this.mainOffice = false;
      this.taxName = '';
      this.tax_phone = '';
      this.email = '';
      this.branchName = '';
      this.branchNo = '';
      this.taxId = '';
      this.address = '';
      this.zipcode = '';
      this.selectedProvinceId = null;
      this.province_name = '';
      this.filteredAmphures = [];
      this.selectedAmphureId = null;
      this.amphure_name = '';
      this.filteredTambons = [];
    }
  }



  /* ----- Modal Address ----- */
  openAddressModal() {
    this.showAddressModal = true;
  }
  getAddressByTaxId() {
    if (!this.taxId.trim()) {
      this.toast.error('กรุณาระบุเลขผู้เสียภาษีก่อน');
    } else {
      this.isLoading = true;
      this.ApigetAddressByTaxId();
    }
  }
  ApigetAddressByTaxId() {
    this.apiService.getAddressByTaxId(this.taxId.trim()).subscribe({
      next: (response: TaxpayerInfo) => {
        this.isLoading = false;
        //  //console.log(JSON.stringify(response).toString());
        if (!response || Object.keys(response).length === 0) {
          this.toast.error('ไม่พบข้อมูลผู้เสียภาษี');
          return;
        } else {
          this.taxName =
            response.company_branch_title_name + ' ' + response.company_name;
          this.address =
            response.company_address_no +
            ' หมู่ที่ ' +
            response.company_moo_number;
          if (response.company_branch_number === '0') {
            this.mainOffice = true;
          } else {
            this.mainOffice = false;
            this.branchName = response.company_branch_name;
          }
          const matchedProvince = this.provincess.find(
            (p) => p.name_th.trim() === response.company_province
          );
          if (matchedProvince) {
            this.selectedProvinceId = matchedProvince.id;
            this.province_name = response.company_province;
          } else {
            this.selectedProvinceId = null;
            this.province_name = '';
          }
          if (this.selectedProvinceId != null) {
            const provinceId = this.selectedProvinceId;
            this.filteredAmphures = this.amphures.filter(
              (a) => a.province_id === +provinceId
            );

            const selectedAmphureName = response.company_amphur;
            const matchedAmphure = this.filteredAmphures.find(
              (a) => a.name_th.trim() === selectedAmphureName
            );
            if (matchedAmphure) {
              this.selectedAmphureId = matchedAmphure.id;
              this.amphure_name = selectedAmphureName;
            } else {
              this.selectedAmphureId = null;
              this.amphure_name = '';
            }
          } else {
            this.filteredAmphures = [];
            this.selectedAmphureId = null;
            this.amphure_name = '';
          }
          if (this.selectedAmphureId != null) {
            const amphureId = this.selectedAmphureId;

            // กรองตำบลในอำเภอที่เลือก
            this.filteredTambons = this.tambons.filter(
              (a) => a.amphure_id === +amphureId
            );

            // ดึงชื่อจากที่อยู่
            const selectedTambonName = response.company_thambol;

            // หาใน list ว่าตรงกับตำบลไหน
            const matchedTambon = this.filteredTambons.find(
              (a) => a.name_th.trim() === selectedTambonName
            );

            if (matchedTambon) {
              this.selectedTambonId = matchedTambon.id;
              this.tambon_name = selectedTambonName;
              this.zipcode = response.company_postcode;
            } else {
              this.selectedTambonId = null;
              this.tambon_name = '';
              this.zipcode = '';
            }
          } else {
            this.filteredTambons = [];
            this.selectedTambonId = null;
            this.tambon_name = '';
          }
        }
      },
      error: (error) => {
        console.error('API error:', error);
        this.isLoading = false;
      },
    });
  }
  onProvinceChange() {
    // //console.log(this.selectedProvinceId);
    this.selectedAmphureId = null;
    this.selectedTambonId = null;
    this.zipcode = '';
    this.amphure_name = '';
    this.tambon_name = '';
    this.filteredAmphures =
      (this.selectedProvinceId ?? null) !== null
        ? this.amphures.filter(
          (a) => a.province_id === +this.selectedProvinceId!
        )
        : [];
    if (this.provincess.length && this.selectedProvinceId) {
      const province = this.provincess.find(
        (a) => a.id === Number(this.selectedProvinceId)
      );
      this.province_name = province ? province.name_th : '';
      // //console.log('✅ province_name:', this.province_name);
    } else {
      console.warn('⚠️ province list or selectedProvinceId not ready');
    }

    this.filteredTambons = []; // reset
  }
  onAmphureChange() {
    this.selectedTambonId = null;
    this.zipcode = '';
    this.tambon_name = '';
    this.filteredTambons =
      (this.selectedAmphureId ?? null) !== null
        ? this.tambons.filter((a) => a.amphure_id === +this.selectedAmphureId!)
        : [];
    if (this.amphures.length && this.selectedAmphureId) {
      const amphure = this.amphures.find(
        (a) => a.id === Number(this.selectedAmphureId)
      );
      this.amphure_name = amphure ? amphure.name_th : '';
      // //console.log('✅ amphure_name:', this.amphure_name);
    }
  }
  onTambonsChange() {
    // //console.log(this.selectedTambonId);
    this.zipcode = '';
    this.zipcode =
      (this.selectedTambonId ?? null) !== null
        ? this.tambons.filter((t) => t.id === +this.selectedTambonId!)[0]
          ?.zip_code || ''
        : '';

    if (this.tambons.length && this.selectedTambonId) {
      const tambon = this.tambons.find(
        (a) => a.id === Number(this.selectedTambonId)
      );
      this.tambon_name = tambon ? tambon.name_th : '';
      // //console.log(this.tambon_name);
    }
  }
  filterProvinces() {
    return this.ProvinceOptions.filter((ProvinceOptions) =>
      ProvinceOptions.label
        .toLowerCase()
        .includes(this.searchTerm.toLowerCase())
    );
  }
  selectProvince(province: any) {
    // this.insertLicensePlate.province = province.value;
    this.provinceTxt = province.value;
    this.isOpen = false;
    //console.log('เลือกจังหวัด:', province);
  }
  handleBrandChange(event: any): void {
    this.selectedBrand = event.target.value;
    //console.log('Selected Brand ID:', this.selectedBrand);
    this.updateModelOptions(this.selectedBrand || '');
  }
  updateModelOptions(brand: string): void {
    // กรองข้อมูลตามประเภทที่เลือก
    const filteredModel = this.couponDetails
      .filter(
        (brands) =>
          brands.vehicle_brand_name === brand &&
          brands.vehicle_type_name === this.selectedCar
      ) // กรองตามประเภทที่เลือก
      .map((brands) => brands.vehicle_model_name); // ดึงแค่ vehicle_brand_name

    // กรองค่าซ้ำจาก filteredBrands
    const uniqueBrands = [...new Set(filteredModel)];
    this.selectedModel = '';
    this.selectEngine = '';
    // อัปเดต BrandOptions โดยใช้ค่าที่ไม่ซ้ำดอ
    this.ModelOptions = uniqueBrands.map((model) => ({
      value: model,
      label: model,
    }));
  }
  summit() {
    this.showTaxModal = false;
  }
  handleColorChange(event: any): void {
    this.selectedColor = event.target.value;
    //console.log('Selected Color ID:', this.selectedColor);
    // this.updateModelOptions(this.selectedBrand || '');
  }
  handleModelChange(event: any): void {
    this.selectedModel = event.target.value;
    this.selectEngine = '';
    //console.log('Selected Model ID:', this.selectedModel);

    const filteredEngines = this.couponDetails
      .filter(
        (brands) =>
          brands.vehicle_brand_name === this.selectedBrand &&
          brands.vehicle_type_name === this.selectedCar &&
          brands.vehicle_model_name === this.selectedModel
      ) // กรองตามประเภทที่เลือก
      .map((brands) => brands.vehicle_engine_name);

    this.selectEngine = filteredEngines[0] || '';
    //console.log('Selected Engine:', this.selectEngine);
  }
  // Modal license plate
  submitModalVehiclePlate() {
    // Insert License
    if (this.licenseTxt == '') {
      this.toast.warn('กรุณาระบุทะเบียนรถ');
    } else if (this.provinceTxt == '') {
      this.toast.warn('กรุณาระบุเลขจังหวัด');
    } else if (this.brandTxt == '') {
      this.toast.warn('กรุณาระบุแบรนด์รถ');
    } else if (this.modelTxt == '') {
      this.toast.warn('กรุณาระบุทะรุ่นรถ');
    } else if (this.colorTxt == '') {
      this.toast.warn('กรุณาระบุสีรถ');
    } else {
      const payload: InsertLicensePayload = {
        uid: this.selectMember?.lineId || '',
        license: this.licenseTxt.replace(/\s+/g, ''),
        vehicle_type: this.selectVehicleType || '',
        brand: this.selectedBrand || '',
        model: this.selectedModel || '',
        engine_type: this.selectEngine || '',
        color: this.selectedColor || '',
        province: this.provinceTxt,
      };
      //console.log(payload);
      if (payload) {
        this.sentLincenseInsert(payload);
      } else {
        //console.log('No Payload');
      }
    }

    // this.showModalVehiclePlate = false;
    // Render HTML don't use push
    // this.licenseFilteredPlateList = [...this.licenseFilteredPlateList, this.newLicensePlate];
    // //console.log('New license : ' , this.newLicensePlate , this.licenseAll);
  }
  /* ------------------------------------------------ API ------------------------------------------------ */
  getFeeType() {
    this.apiFormService.getFeeType().subscribe({
      next: (response: FeeType[]) => {
        //console.log('getFeeType', response);
        this.FeeTypeOptions = response.map((feetype) => ({
          value: feetype.id,
          label: feetype.name,
          status: feetype.requestBank || false,
        }));
      },
      error: (error) => {
        console.error('API error:', error);
      },
    });
  }
  getProviders() {
    this.apiFormService.getProviders().subscribe({
      next: (res) => {
        Swal.close();
        // //console.log('res : ', res);
        this.allProviders = res;
      },
      error: (err) => {
        console.error('โหลดบัตรสมาชิกล้มเหลว', err);
        Swal.close();
      },
    });
  }
  getBank(site_id: number) {
    //console.log('getBank', site_id);
    this.apiFormService.getBank(site_id).subscribe({
      next: (response: Blank[]) => {
        this.BankOptions = response.map((bank) => ({
          value: bank.id,
          label: bank.bankName + ' (' + bank.accountNumber + ')',
        }));
      },
      error: (error) => {
        console.error('API error:', error);
      },
    });
  }
  getFeeId() {
    this.apiService.getFeeMaster().subscribe({
      next: (response: MasterFee[]) => {
        //console.log('getFeeId', response);        
        this.FeeIdOptions = response;
      },
      error: (error) => {
        console.error('API error:', error);
      },
    });
  }
  requestGetCouponDetail() {
    this.isLoading = true;
    this.apiService.getCouponInfo().subscribe({
      next: (response: FinanceCoupon[]) => {
        //console.log('🌎 response Get Coupon :', response);
        this.financeData = response
        this.financeData.push(...response);


        // setTimeout(() => {
        //   this.getUserVehicle();
        //   this.getUserVehicleAll();
        // }, 100);

        this.isLoading = false;
      },
      error: (error) => {
        console.error('API error:', error);
        this.isLoading = false;
      },
    });
  }
  getMemberCardApi(site_id: number, uid: string) {
    this.apiService.getMyMemberCard(uid, site_id).subscribe({
      next: (response: MyMemberCard[]) => {
        //console.log(response);
        this.allMemberCard = response;
      },
      error: (error) => {
        console.error('API error:', error);
        this.isLoading = false;
      },
    });
  }
  getUserVehicleAll() {
    //console.log('providerId', this.providerId);
    if (this.renew_) {
      //console.log('Re NEW');
      // this.getUserVehicleAllByCardCode();
      // this.apiService
      //   .getVehicleMemberInfo(
      //     this.selectMember?.lineId || '',
      //     this.providerId,
      //     this.card
      //   )
      //   .subscribe({
      //     next: (response: MyVehicleAllResponse[]) => {
      //       //console.log('MyVehicleAllResponse', response);
      //       this.setValueVehicle(response);
      //     },
      //     error: (error) => {
      //       console.error('API error:', error);
      //       this.isLoading = false;
      //     },
      //   });
    } else {
      //console.log('NEW');
      this.apiService
        .getVehicleUserAllBySite(
          this.selectMember?.lineId || '',
          this.providerId
        )
        .subscribe({
          next: (response: MyVehicleAllResponse[]) => {
            //console.log('MyVehicleAllResponse', response);
            this.setValueVehicle(response);
          },
          error: (error) => {
            console.error('API error:', error);
            this.isLoading = false;
          },
        });
    }
  }

  /* --------------- Coupon Veiw --------------*/
  getApiCouponInfo(data: FinanceCoupon) {
    {
      this.apiService.getCouponViewInfo(data.siteId ? data.siteId : 0).subscribe({
        next: (response: FinanceCouponResponse) => {
          //console.log('response Coupon :', response);
          this.financeDetailsData = response;
          this.previewUrl = response.pic;

          this.isRequestTax = true;
          this.showBank = false;
          this.isLoading = false;
        },
        error: (error) => {
          console.error('API error:', error);
          this.isLoading = false;
          this.isRequestTax = true;
        },
      });
    }
  }

}
